import {Box, Center, Flex, Image, Text} from '@chakra-ui/react'
import Volume from '@assets/svgs/learn/volume_1.svg'
import SaveIcon from '@assets/svgs/learn/save.svg'
import SaveIcon2 from '@assets/svgs/learn/save_2.svg'
import {useEffect, useRef, useState} from 'react'
import vocabularyRequest from '@apis/vocabulary'
import {
  updateIsShowSavePhraseForm,
  updatePhraseToSave,
} from '@redux/shared/shared'
import {useDispatch, useSelector} from 'react-redux'
import {Navigate, useLocation, useNavigate} from 'react-router-dom'
import SavePhraseForm from '@components/SavePhraseForm'
import {isParamsValid} from '@utils'
import {PATH} from '@utils/Const'

const Content = () => {
  const {phraseToSave} = useSelector((state: any) => state.shared)
  const [vocabularySummaries, setVocabularySummaries] = useState<any>()
  const [isSave, setIsSave] = useState<any>({})
  const [isSaveAll, setIsSaveAll] = useState<any>(false)
  const [isLoadingSaveAll, setIsLoadingSaveAll] = useState<any>(false)
  const dispatch = useDispatch()
  const location = useLocation()
  const {setId} = location.state || {}
  const audioRef = useRef<any>()
  const navigate = useNavigate()

  useEffect(() => {
    if (!isParamsValid([setId])) {
      navigate(PATH.HOME)
    }
  }, [])

  useEffect(() => {
    if (!setId) return
    getVocabularySummaries()
  }, [])
  const getVocabularySummaries = async () => {
    await vocabularyRequest.getVocabularySummaries(setId).then(res => {
      setVocabularySummaries(res?.data?.data)
      if (res?.data?.data?.is_saved_all) {
        setIsSaveAll(true)
      }
    })
  }

  const handlePlayAudio = (file: any) => {
    audioRef.current?.pause()
    audioRef.current = new Audio(file)
    audioRef.current.play()
  }

  const handleSavePhrase = async (item: any) => {
    dispatch(updateIsShowSavePhraseForm(true))
    dispatch(updatePhraseToSave(item.text_en))
  }

  const handleAfterSuccess = () => {
    setIsSave((pre: any) => ({
      ...pre,
      [phraseToSave.replace(/ /g, '_')]: true,
    }))
  }

  const handleSaveAll = async () => {
    setIsLoadingSaveAll(true)
    try {
      const params = {
        set_id: setId,
      }

      const res = await vocabularyRequest.saveAllVocabularies(params)
      setIsSaveAll(true)
      let newIsSave: any = {}

      vocabularySummaries?.vocabularies?.forEach((item: any) => {
        newIsSave[item.text_en.replace(/ /g, '_')] = true
      })

      setIsSave(newIsSave)
    } catch (error) {}
    setIsLoadingSaveAll(false)
  }

  return (
    <>
      <Box
        className="container-xl scroll-bar"
        overflow={'auto'}
        mt={'-80px'}
        bg={'white'}
        h={'100%'}
        minH={'400px'}
        maxH={'550px'}
        borderRadius={'20px'}
        p={{base: '16px', md: '24px'}}>
        {vocabularySummaries?.vocabularies.length > 0 ? (
          <>
            {vocabularySummaries?.vocabularies?.map((item: any, index: any) => (
              <Flex
                key={index}
                gap={'8px'}
                p={'16px'}
                borderRadius={'16px'}
                alignItems={'center'}
                _hover={{
                  bg: '#F0F4FF',
                }}>
                <Flex flex={1} gap={'16px'}>
                  <Image
                    src={Volume}
                    cursor={'pointer'}
                    onClick={() => handlePlayAudio(item.audio)}
                  />
                  <Box>
                    <Text
                      fontSize={{base: '14px', md: '16px'}}
                      fontWeight={600}
                      color={'#1F1F1F'}>
                      {item.text_en}
                    </Text>
                    <Text
                      fontSize={{base: '14px', md: '16px'}}
                      color={'#8C8C8C'}>
                      {item.text_vi}
                    </Text>
                  </Box>
                </Flex>
                <Center
                  w={{base: '110px', md: '126px'}}
                  h={{base: '40px', md: '40px'}}
                  gap={'4px'}
                  cursor={'pointer'}
                  border={'1px solid #2F54EB'}
                  borderRadius={'12px'}
                  bg={
                    isSave[item.text_en.replace(/ /g, '_')] ||
                    item?.is_saved_to_notebook
                      ? '#061178'
                      : 'unset'
                  }
                  onClick={() => handleSavePhrase(item)}>
                  <Image
                    src={
                      isSave[item.text_en.replace(/ /g, '_')] ||
                      item?.is_saved_to_notebook
                        ? SaveIcon2
                        : SaveIcon
                    }
                    w={'24px'}
                  />
                  <Text
                    color={
                      isSave[item.text_en.replace(/ /g, '_')] ||
                      item?.is_saved_to_notebook
                        ? 'white'
                        : '#1D39C4'
                    }
                    fontWeight={700}>
                    {isSave[item.text_en.replace(/ /g, '_')] ||
                    item?.is_saved_to_notebook
                      ? 'Đã lưu'
                      : 'Lưu cụm'}
                  </Text>
                </Center>
              </Flex>
            ))}
            <Flex justify={'flex-end'} p={'16px'}>
              <Center
                w={'150px'}
                h={{base: '40px', md: '40px'}}
                gap={'4px'}
                cursor={
                  isLoadingSaveAll || isSaveAll ? 'not-allowed' : 'pointer'
                }
                border={'1px solid #2F54EB'}
                borderRadius={'12px'}
                bg={isSaveAll ? '#061178' : 'unset'}
                onClick={
                  isLoadingSaveAll || isSaveAll ? undefined : handleSaveAll
                }>
                <Image src={isSaveAll ? SaveIcon2 : SaveIcon} w={'24px'} />
                <Text color={isSaveAll ? 'white' : '#1D39C4'} fontWeight={700}>
                  {isLoadingSaveAll
                    ? 'Đang lưu...'
                    : isSaveAll
                      ? 'Đã lưu tất cả'
                      : 'Lưu tất cả'}
                </Text>
              </Center>
            </Flex>
          </>
        ) : (
          <Text>Không có cụm nào.</Text>
        )}
      </Box>
      <SavePhraseForm handleAfterSuccess={handleAfterSuccess} />
    </>
  )
}

export default Content
